import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { GooglePlacesAutocompleteRequestType, GTM_EC_EVENT_FIELD } from 'constants/google';
export const buildComponentRestrictions = country => {
  if (!country) return undefined;
  return {
    country
  };
};
export const buildGooglePlacesAutocompleteRequest = _ref => {
  let {
    value,
    country,
    sessionToken,
    type = GooglePlacesAutocompleteRequestType.Geocode
  } = _ref;
  return {
    input: value || '',
    sessionToken: sessionToken || {},
    types: [type],
    componentRestrictions: buildComponentRestrictions(country)
  };
};
export const buildGooglePlaceDetailsRequest = function buildGooglePlaceDetailsRequest(placeId, sessionToken) {
  let fields = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['address_component', 'formatted_address', 'geometry'];
  return {
    placeId,
    sessionToken,
    fields
  };
};
export const googleTagManagerTrack = function googleTagManagerTrack(event, data) {
  let isGtmEcFieldEnabled = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  const eventData = _objectSpread(_objectSpread({}, data), {}, {
    event
  });

  if (!isGtmEcFieldEnabled) {
    delete eventData[GTM_EC_EVENT_FIELD];
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(eventData);
};
export const getAddressComponent = function getAddressComponent(componentType, placeDetails) {
  var _placeDetails$address;

  let returnShortName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  const addressComponent = (_placeDetails$address = placeDetails.address_components) === null || _placeDetails$address === void 0 ? void 0 : _placeDetails$address.find(component => {
    return component.types.find(type => type === componentType) && component;
  });
  if (returnShortName) return addressComponent === null || addressComponent === void 0 ? void 0 : addressComponent.short_name;
  return addressComponent === null || addressComponent === void 0 ? void 0 : addressComponent.long_name;
};
export const geocodeAddress = address => {
  var _window$google;

  if (!((_window$google = window.google) !== null && _window$google !== void 0 && _window$google.maps)) return Promise.resolve(undefined);
  return new Promise(resolve => {
    new window.google.maps.Geocoder().geocode({
      address
    }, results => {
      resolve(results === null || results === void 0 ? void 0 : results[0]);
    });
  });
};
export const getGooglePlacePredictions = options => new Promise(resolve => {
  var _window, _window$google2;

  if (typeof ((_window = window) === null || _window === void 0 ? void 0 : (_window$google2 = _window.google) === null || _window$google2 === void 0 ? void 0 : _window$google2.maps) === 'undefined') resolve(null);
  if (!options.value) resolve(null);

  try {
    new window.google.maps.places.AutocompleteService().getPlacePredictions(buildGooglePlacesAutocompleteRequest(options), (predictions, status) => {
      if (status !== window.google.maps.places.PlacesServiceStatus.OK) return;
      resolve(predictions);
    });
  } catch (_unused) {
    resolve(null);
  }
});
export const getGooglePlaceDetails = _ref2 => {
  let {
    placeId,
    inputName,
    sessionToken
  } = _ref2;
  return new Promise(resolve => {
    var _window2, _window2$google;

    const input = document.getElementById(inputName);

    if (typeof ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$google = _window2.google) === null || _window2$google === void 0 ? void 0 : _window2$google.maps) === 'undefined' || !placeId || !input || !sessionToken) {
      resolve(null);
      return;
    }

    try {
      new window.google.maps.places.PlacesService(new window.google.maps.Map(input)).getDetails(buildGooglePlaceDetailsRequest(placeId, sessionToken), (placeDetails, status) => {
        if (!placeDetails) return;
        if (status !== window.google.maps.places.PlacesServiceStatus.OK) return;
        resolve(placeDetails);
      });
    } catch (_unused2) {
      resolve(null);
    }
  });
};